import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyFaqList = loadable(() => import(/* webpackChunkName: "content/guest/widgets/faqList" */ './FaqList'), 'FaqList');
